import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { isError } from "@faire/web--source/common/typescriptUtils";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
var isRawResponse = function(r) {
    if (!r || (typeof r === "undefined" ? "undefined" : _type_of(r)) !== "object") {
        return false;
    }
    var obj = r;
    var isSuccessResponse = "data" in obj && typeof obj["status"] === "number" && "headers" in obj;
    var isFailureResponse = "error" in obj && isError(obj.error);
    return isSuccessResponse || isFailureResponse;
};
var getFaireApiNamespace = function() {
    var faire = getGlobalProperty("faire");
    if (!faire) {
        throw new Error("Faire global not found");
    }
    var api = faire.api || (faire.api = {});
    return api;
};
export var REQUEST_HANDLER_GLOBAL_KEY = "faire.api.handler";
export var getRequestHandler = function() {
    return getGlobalProperty(REQUEST_HANDLER_GLOBAL_KEY);
};
/**
 * Sets the global request handler, i.e. global.faire["api"]["handler"].
 * The request handler is later resolved via getRequestHandler (getGlobalProperty("faire.api.handler")),
 * so in a Zone context (i.e. SSR), this should be done using Zone.fork, setting "faire.api.handler".
 */ export var setRequestHandler = function(handler) {
    getFaireApiNamespace().handler = handler;
};
export var REQUEST_INTERCEPTOR_GLOBAL_KEY = "faire.api.requestInterceptors";
export var getRequestInterceptors = function() {
    var _getGlobalProperty;
    var requestInterceptors = (_getGlobalProperty = getGlobalProperty(REQUEST_INTERCEPTOR_GLOBAL_KEY)) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    return Object.freeze(requestInterceptors.slice(0));
};
/**
 * Sets a global request interceptor.
 * The request interceptors are invoked before the request handler called.
 */ export var addRequestInterceptor = function(interceptor) {
    var _getFaireApiNamespace_requestInterceptors;
    var interceptors = getFaireApiNamespace().requestInterceptors = (_getFaireApiNamespace_requestInterceptors = getFaireApiNamespace().requestInterceptors) !== null && _getFaireApiNamespace_requestInterceptors !== void 0 ? _getFaireApiNamespace_requestInterceptors : [];
    interceptors.push(interceptor);
};
export var RESPONSE_INTERCEPTOR_GLOBAL_KEY = "faire.api.responseInterceptors";
export var getResponseInterceptors = function() {
    var _getGlobalProperty;
    var repsonseInterceptors = (_getGlobalProperty = getGlobalProperty(RESPONSE_INTERCEPTOR_GLOBAL_KEY)) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    return Object.freeze(repsonseInterceptors.slice(0));
};
/**
 * Sets a global request interceptor.
 * The request interceptors are invoked before the request handler called.
 */ export var addResponseInterceptor = function(interceptor) {
    var _getFaireApiNamespace_responseInterceptors;
    var interceptors = getFaireApiNamespace().responseInterceptors = (_getFaireApiNamespace_responseInterceptors = getFaireApiNamespace().responseInterceptors) !== null && _getFaireApiNamespace_responseInterceptors !== void 0 ? _getFaireApiNamespace_responseInterceptors : [];
    interceptors.push(interceptor);
};
export function request(config) {
    return _request.apply(this, arguments);
}
function _request() {
    _request = _async_to_generator(function(config) {
        var requestHandler, interceptors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err, response, e, _getResponseInterceptors, interceptors1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, i1, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestHandler = getRequestHandler();
                    if (requestHandler === undefined) {
                        throw new Error("Error: request handler does not exist! Please use setRequestHandler() to set one.");
                    }
                    if (config.ignoreDuringPrerender && isPrerender()) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    if (config.ignoreForRobots && isRobot()) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    if ((config.method === "post" || config.method === "put") && !config.data) {
                        config.data = {};
                    }
                    interceptors = getRequestInterceptors();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = interceptors[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    i = _step.value;
                    return [
                        4,
                        i(config)
                    ];
                case 3:
                    config = _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        10,
                        ,
                        11
                    ]);
                    return [
                        4,
                        requestHandler(config)
                    ];
                case 9:
                    response = _state.sent();
                    return [
                        3,
                        11
                    ];
                case 10:
                    e = _state.sent();
                    if (isError(e)) {
                        response = {
                            error: e
                        };
                    } else {
                        response = {
                            error: new Error("Unexpected error thrown while handling ".concat(config.method, " ").concat(config.url))
                        };
                    }
                    return [
                        3,
                        11
                    ];
                case 11:
                    if (!isRawResponse(response)) return [
                        3,
                        20
                    ];
                    interceptors1 = (_getResponseInterceptors = getResponseInterceptors()) !== null && _getResponseInterceptors !== void 0 ? _getResponseInterceptors : [];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 12;
                case 12:
                    _state.trys.push([
                        12,
                        17,
                        18,
                        19
                    ]);
                    _iterator1 = interceptors1[Symbol.iterator]();
                    _state.label = 13;
                case 13:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        16
                    ];
                    i1 = _step1.value;
                    return [
                        4,
                        i1(config, response)
                    ];
                case 14:
                    response = _state.sent();
                    _state.label = 15;
                case 15:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        13
                    ];
                case 16:
                    return [
                        3,
                        19
                    ];
                case 17:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        19
                    ];
                case 18:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 19:
                    if ("error" in response) {
                        throw response.error;
                    } else if (config.rawResponse !== true) {
                        response = response.data;
                    }
                    _state.label = 20;
                case 20:
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _request.apply(this, arguments);
}
/**
 * Sets a global event interceptor.
 * The event interceptors are invoked when an event is tracked.
 */ export var addEventInterceptor = function(interceptor) {
    var _getFaireEventsNamespace_interceptors;
    var interceptors = getFaireEventsNamespace().interceptors = (_getFaireEventsNamespace_interceptors = getFaireEventsNamespace().interceptors) !== null && _getFaireEventsNamespace_interceptors !== void 0 ? _getFaireEventsNamespace_interceptors : [];
    interceptors.push(interceptor);
};
var getFaireEventsNamespace = function() {
    var faire = getGlobalProperty("faire");
    if (!faire) {
        throw new Error("Faire global not found");
    }
    var events = faire.events || (faire.events = {});
    return events;
};
